import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationGroup4MasterReferenceData = createAsyncThunk(
  'stop/getVerificationGroup4MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationGroup4MasterReferenceSlice = createSlice({
  name: 'stop/verificationGroup4MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationGroup4MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationGroup4MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationGroup4MasterReference } =
  verificationGroup4MasterReferenceSlice.actions;

export default verificationGroup4MasterReferenceSlice.reducer;
